import Joi from 'joi'

import { EntityConstants } from 'constants/index'

const ConfirmCancellationOrLostDialogValidation = Joi.object({
  cancellationOrLostReasonId: Joi.string().empty('').required(),
  cancellationOrLostReasonDetails: Joi.string()
    .label('Cancellation Or Lost Reason Details')
    .empty('')
    .max(EntityConstants.MAX_SHORT_NOTE_LENGTH)
    .optional(),
})

export { ConfirmCancellationOrLostDialogValidation }
